var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.997,
    viewBox: "0 0 18 17.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_stato",
    transform: "translate(-0.25 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2254",
    d: "M6.345,7.973H1.934A1.686,1.686,0,0,1,.25,6.289V1.934A1.686,1.686,0,0,1,1.934.25h4.41A1.686,1.686,0,0,1,8.029,1.934V6.289A1.686,1.686,0,0,1,6.345,7.973ZM1.934,1.554a.381.381,0,0,0-.38.38V6.289a.381.381,0,0,0,.38.38h4.41a.38.38,0,0,0,.38-.38V1.934a.38.38,0,0,0-.38-.38Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2255",
    d: "M6.386,27.668H1.975A1.687,1.687,0,0,1,.291,25.984V21.629a1.686,1.686,0,0,1,1.684-1.684h4.41a1.686,1.686,0,0,1,1.683,1.684v4.355a1.686,1.686,0,0,1-1.683,1.684Zm-4.41-6.419a.381.381,0,0,0-.38.38v4.355a.381.381,0,0,0,.38.38h4.41a.381.381,0,0,0,.38-.38V21.629a.38.38,0,0,0-.38-.38Z",
    transform: "translate(-0.02 -9.421)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2256",
    d: "M25.934,27.668h-4.41a1.687,1.687,0,0,1-1.684-1.684V21.629a1.686,1.686,0,0,1,1.684-1.684h4.41a1.686,1.686,0,0,1,1.684,1.684v4.355a1.686,1.686,0,0,1-1.684,1.684Zm-4.41-6.416a.381.381,0,0,0-.38.38v4.355a.381.381,0,0,0,.38.38h4.41a.381.381,0,0,0,.38-.38V21.629a.38.38,0,0,0-.38-.38Z",
    transform: "translate(-9.37 -9.421)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2257",
    d: "M23.787,7.976a3.86,3.86,0,1,1,3.889-3.86,3.86,3.86,0,0,1-3.889,3.86Zm0-6.416a2.556,2.556,0,1,0,2.585,2.556,2.556,2.556,0,0,0-2.585-2.556Z",
    transform: "translate(-9.426 -0.002)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAction);
export default __webpack_public_path__ + "static/media/status_action.b57e2bf58830bb903ef071635261ac39.svg";
export { ForwardRef as ReactComponent };